// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__EZ3c8","options":"AnswerScale_options__2aBp_","selected":"AnswerScale_selected__vdyuC"};